import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';

import { AiCopilotDrawer } from '../../../components/ai-copilot/AiCopilotDrawer';
import { AiCopilotProvider } from '../../../components/ai-copilot/context/AiCopilotProvider';
import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { USAGE_DATA_REPORT_CONTEXT } from '../usage-data-report-suggestions';
import { UsageReportV2ReportContent } from './usage-report-v2-report-components/UsageReportV2ReportContent';

const UsageReportV2ReportLayout: React.FC = () => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <>
      <Box
        sx={{
          transition: (theme) =>
            theme.transitions.create('margin-right', {
              easing: isOpen
                ? theme.transitions.easing.easeOut
                : theme.transitions.easing.sharp,
              duration: isOpen
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
          marginRight: isOpen ? `${drawerWidth}px` : 0,
        }}
      >
        <VyLayout>
          <UsageReportV2ReportContent />
        </VyLayout>
      </Box>
      <AiCopilotDrawer />
    </>
  );
};

// The Usage Report v2 has no dedicated backend chat route; its consumption / commitment-unit /
// usage-by-product columns are answered by the commitment domain tools (reportContext below).
const USAGE_REPORT_SUGGESTIONS = [
  'How much has each customer consumed so far?',
  'Show usage by product',
  'Which customers are closest to their commitment?',
  'Show the monthly usage trend',
  'Which products are driving the most usage?',
];

const UsageReportV2ReportPage: React.FC = () => {
  return (
    <AiCopilotProvider suggestions={USAGE_REPORT_SUGGESTIONS} reportContext={USAGE_DATA_REPORT_CONTEXT}>
      <Helmet>
        <title>Usage Report v2</title>
      </Helmet>
      <UsageReportV2ReportLayout />
    </AiCopilotProvider>
  );
};

const UsageReportV2ReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(UsageReportV2ReportPage),
);

export { UsageReportV2ReportPageWithSuspenseBoundary as UsageReportV2ReportPage };
